import { bffServiceClient } from 'packages/request/clients';
import { getData } from 'helpers/request';
import {
  IApprovePromotionRequestPayload,
  IGetPromotionRequestsResponse,
  IGetPromotionResquestParams,
  IGetVoucherResponse,
} from 'interfaces';

const getListPromotionRequest = (
  params: IGetPromotionResquestParams
): Promise<IGetPromotionRequestsResponse> => {
  return bffServiceClient.get('/promotionRequest', { params }).then(getData);
};

const approvePromotionRequest = (
  id: number,
  payload: IApprovePromotionRequestPayload
) => {
  return bffServiceClient.put(`/promotionRequest/${id}/approve`, payload);
};

const getVouchers = (params: {
  shopId: number;
}): Promise<IGetVoucherResponse> => {
  return bffServiceClient
    .get('/salePortalVoucherCode', { params })
    .then(getData);
};

const registerPromotionProgram = (payload: {
  shopId: number;
  voucherCodeId: number;
}): Promise<{}> => {
  return bffServiceClient.post('/promotionRequest', payload).then(getData);
};

export default {
  getListPromotionRequest,
  approvePromotionRequest,
  getVouchers,
  registerPromotionProgram,
};
